export function canUseDOM(): boolean {
  return !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  )
}

export const isBrowser = canUseDOM()

export function waitForGoogleMaps(callback: CallableFunction) {
  if (
    typeof google === "object" &&
    typeof google.maps === "object" &&
    typeof google.maps.places === "object"
  ) {
    callback() // Google Maps and Places library are loaded
  } else {
    window.setTimeout(() => {
      waitForGoogleMaps(callback)
    }, 250) // Retry after 250ms
  }
}

export const isDesktop = () => {
  return window.innerWidth >= 992
}

export const isMobile = () => {
  return window.innerWidth < 992
}
